import loadImage from 'blueimp-load-image';

export function fixOrientation(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      (imgOrEvent: Event | HTMLImageElement | HTMLCanvasElement) => {
        if (imgOrEvent instanceof Event) {
          reject(new Error('Error loading image'));
          return;
        }

        if (imgOrEvent instanceof HTMLCanvasElement) {
          imgOrEvent.toBlob((blob) => {
            if (!blob) return reject(new Error('Canvas toBlob failed'));
            resolve(new File([blob], file.name, { type: file.type }));
          }, file.type);
          return;
        }

        reject(new Error('Canvas not created'));
      },
      { orientation: true, canvas: true },
    );
  });
}
